import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, PdfGenerateRequest } from '../types/showcase';

/** C079 PDF 데모(순수) — POST .../pdf/generate (queue #646 §R646-2). */
export function usePdfGenerate() {
  return useMutation<Blob, ApiError, PdfGenerateRequest>({
    mutationFn: (req) => showcaseApi.pdfGenerate(req),
    mutationKey: ['common-showcase', 'pdf', 'generate'],
  });
}
